import React from 'react';
import {
  Box,
  Typography,
  Paper,
} from '@mui/material';

interface TimelineItemProps {
  history: any;
  isLast: boolean;
  authUser: any;
}

export const TimelineItem: React.FC<TimelineItemProps> = React.memo(({ 
  history, 
  isLast, 
  authUser 
}) => {
  const getStatusIcon = (statusId: number) => {
    const icons: any = {
      1: '🆕', 2: '👤', 3: '🚀', 4: '🧪', 5: '↩️', 6: '✅', 7: '⏳', 8: '🔒',
    };
    return icons[statusId] || '📝';
  };

  const isContentUpdate = history.notes?.includes('içerik güncellendi') || 
                         history.notes?.includes('İçerik güncellendi') ||
                         history.notes?.includes('content updated');

  if (authUser?.role === 'customer' && isContentUpdate) {
    return null;
  }

  const filteredNotes = authUser?.role === 'customer' && history.notes 
    ? history.notes.replace(/Atanan:\s*[^,]+/, '').replace(/,?\s*$/, '')
    : history.notes;

  return (
    <Box sx={{ 
      display: 'flex', 
      gap: 2, 
      pb: isLast ? 0 : 2,
      position: 'relative',
      '&:not(:last-child)::after': {
        content: '""',
        position: 'absolute',
        left: 20,
        bottom: 0,
        width: 2,
        height: '100%',
        backgroundColor: '#e0e0e0',
      }
    }}>
      <Box sx={{ 
        width: 40,
        height: 40,
        borderRadius: '50%',
        backgroundColor: 'grey.100',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'text.primary',
        fontWeight: 'bold',
        fontSize: 16,
        flexShrink: 0,
        zIndex: 1,
        border: '2px solid #e0e0e0'
      }}>
        {getStatusIcon(history.status_id)}
      </Box>

      <Box sx={{ flex: 1 }}>
        <Typography variant="body1" fontWeight="bold">
          {history.status_name}
        </Typography>
        
        {authUser?.role !== 'customer' && history.assigned_to_name && (
          <Typography variant="body2" color="text.secondary">
            Atanan: {history.assigned_to_name}
          </Typography>
        )}
        
        {authUser?.role !== 'customer' ? (
          <Typography variant="body2" color="text.secondary">
            {history.changed_by_name} • {new Date(history.changed_at).toLocaleString('tr-TR')}
          </Typography>
        ) : (
          <Typography variant="body2" color="text.secondary">
            {new Date(history.changed_at).toLocaleString('tr-TR')}
          </Typography>
        )}
        
        {filteredNotes && (
          <Paper variant="outlined" sx={{ p: 1, mt: 1, backgroundColor: 'grey.50' }}>
            <Typography variant="body2">
              {filteredNotes}
            </Typography>
          </Paper>
        )}
      </Box>
    </Box>
  );
});